import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoAlternativeMui = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 88,
	height: 21,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fill: "#311B92",
			d: "M7.287 13.94H5.023v6.191H0V0h8.118c1.608 0 3.006.304 4.188.908 1.183.604 2.096 1.467 2.74 2.59.644 1.122.964 2.44.964 3.956 0 1.515-.3 2.727-.901 3.812-.601 1.082-1.46 1.93-2.576 2.545l3.833 6.328h-5.379l-3.7-6.19v-.008Zm1.089-9.268h-3.15v4.342h3.15c1.265 0 2.287-.971 2.287-2.171 0-1.2-1.022-2.171-2.287-2.171ZM31.408 12.915v7.22h-5.023v-7.306L19.609 0h5.304l4.212 7.995L33.336 0h4.871l-6.799 12.915ZM77.6 15.734v4.401H63.34V0h13.93v4.401h-8.958v3.394h7.892v4.256h-7.892v3.683H77.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#40E099",
			d: "M58.335 20.135h-8.4c-1.943 0-3.668-.411-5.175-1.237a8.623 8.623 0 0 1-3.5-3.508c-.828-1.516-1.246-3.29-1.246-5.32 0-2.03.414-3.805 1.245-5.32A8.622 8.622 0 0 1 44.76 1.24C46.267.42 47.992.004 49.936.004h8.4v20.131Zm-5.023-4.545V4.546h-3.173c-1.522 0-2.744.489-3.665 1.467-.921.978-1.382 2.33-1.382 4.057 0 1.726.46 3.078 1.382 4.056.921.978 2.143 1.467 3.665 1.467h3.173v-.003Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#311B92",
			d: "M87.273 15.193h-4.508v4.939h4.508v-4.939Z"
		})
	]
});
const ForwardRef = forwardRef(SvgLogoAlternativeMui);
export { ForwardRef as ReactComponent };
